module.exports = __webpack_public_path__ + "img/互动贴纸--表情触发--眨眼gif.4ce16cf1.gif";